import { Entry } from '../Entry'

export function Entry20230724() {
  return (
    <Entry title="Jul 24 2023 - v3.4.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13826/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
